import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { API_ENDPOINTS } from "src/Utils/ApiConstants/ApiUrlConstants";
import Nakad from "../../Graphics/NAKAD_FINAL (1).png";
import useFetch from "../Common/useFetch";
import "../Login/Login.scss";
interface Password {
  password: string;
  confirmPassword: string;
}

const ChangePassword = () => {
  const { token } = useParams<{ token?: string }>();
  const { accountType } = useParams<{ accountType?: string }>();
  const history = useHistory();
  const [changedPassword, setChangedPassword] = useState<Password>({ password: "", confirmPassword: "" });
  const update = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChangedPassword({ ...changedPassword, [event.target.name]: event.target.value });
  };

  useEffect(() => {
    useFetch(API_ENDPOINTS.RESET_PASSWORD(token, accountType).url, "GET", {
      failureMessage: API_ENDPOINTS.RESET_PASSWORD(token, accountType).failureMessage,
      catchCallBack: (error: any) => {
        alert(error.response.data.message);
        history.push("/reset");
      },
    });
  }, [history, token, accountType]);

  const onSubmitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (changedPassword.confirmPassword !== changedPassword.password) {
      alert("Password do not match. Please set it again.");
      history.push(`/reset/${token}/${accountType}`);
      setChangedPassword((p) => {
        p.confirmPassword = "";
        p.password = "";
        return p;
      });
      return;
    }
    await useFetch(API_ENDPOINTS.RESET_PASSWORD(token, accountType).url, "POST", {
      failureMessage: API_ENDPOINTS.RESET_PASSWORD(token, accountType).failureMessage,
      data: { password: changedPassword.password },
      thenCallBack: (response) => {
        alert(response.data.message);
        history.push("/login");
      },
      catchCallBack: (error) => {
        alert(error.response.data.message);
        history.push("/reset");
      },
    });
  };
  return (
    <div className="resetpass_wrapper">
      <div>
        <img src={Nakad} alt="" className="resetlogo" />
        <p className="enter-info-text">Please enter your changed password</p>
        <form onSubmit={onSubmitHandler}>
          <div className="field">
            <div className="control">
              <input
                className="input input-box"
                type="password"
                name="password"
                placeholder="Enter Password"
                value={changedPassword.password}
                onChange={update}
                required={true}
              />
            </div>
          </div>
          <div className="field">
            <div className="control">
              <input
                className="input input-box"
                type="password"
                name="confirmPassword"
                placeholder="Confirm Password"
                value={changedPassword.confirmPassword}
                onChange={update}
                required={true}
              />
            </div>
          </div>
          <button type="submit" className="button login-button">
            Confirm
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
